<template>
  <div class="container">
    <div class="md:grid md:grid-cols-4 md:gap-4">
      <div class="md:col-span-1">
        <div class="px-4 sm:px-0">
          <h3>Profilo utente</h3>
          <p>Informazioni di carattere generale dell'utente</p>
        </div>
      </div>
      <div class="mt-4 md:mt-0 md:col-span-3">
        <div class="shadow sm:overflow-hidden sm:rounded-md">
          <form ref="form">
            <div class="bg-white px-4 py-5 bg-white space-y-6 sm:p-6">
              <div class="grid grid-cols-2 gap-4">
                <div class="col-span-full">
                  <label for="name">Nome completo</label>
                  <t-input
                    name="name"
                    v-model="user.name"
                    placeholder="Nome Cognome"
                    required
                  ></t-input>
                </div>

                <div>
                  <label for="email">Email</label>
                  <t-input
                    name="email"
                    v-model="user.email"
                    placeholder="email@example.com"
                    required
                  ></t-input>
                </div>

                <div>
                  <label for="username">Nome utente</label>
                  <t-input
                    name="username"
                    autocomplete="off"
                    v-model="user.username"
                    placeholder="username"
                    required
                  ></t-input>
                </div>

                <div>
                  <label for="password">Password</label>
                  <t-input
                    name="password"
                    type="password"
                    autocomplete="off"
                    v-model="user.password"
                    :required="isCreating"
                    @blur="checkPasswordMatch"
                  ></t-input>
                </div>

                <div>
                  <label for="password2">Reinserisci password</label>
                  <t-input
                    name="password2"
                    type="password"
                    autocomplete="off"
                    v-model="user.passwordRetype"
                    :required="isCreating"
                    :variant="{ danger: !passwordsMatch }"
                    @blur="checkPasswordMatch"
                  ></t-input>
                  <p v-show="!passwordsMatch" class="text-red-800">
                    Le password non corrispondono
                  </p>
                </div>

                <div>
                  <label for="role">Ruolo</label>
                  <t-select
                    name="role"
                    :options="fetch.roles"
                    placeholder="Scegli un ruolo"
                    v-model="user.role_id"
                    value-attribute="id"
                    text-attribute="description"
                    required
                  ></t-select>
                </div>

                <div class="col-span-full">
                  <div class="flex justify justify-end gap-2">
                    <t-button type="submit" native @click.prevent="submit"
                      >Salva</t-button
                    >
                    <t-button type="reset" variant="neutral">Reset</t-button>
                  </div>
                </div>

                <div class="col-span-full">
                  <t-alert
                    variant="danger"
                    :show="alert.show"
                    @hidden="alert.show = false"
                    >{{ alert.message }}</t-alert
                  >
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
class User {
  constructor() {
    this.id = null;
    this.username = null;
    this.password = null;
    this.passwordRetype = null;
    this.name = null;
    this.email = null;
    this.role_id = null;
  }

  validate() {
    return (
      this.username != null &&
      this.password &&
      this.password == this.passwordRetype &&
      this.role_id != null
    );
  }
}

export default {
  props: {
    id: {
      type: Number,
      required: false,
      default: null,
    },
  },

  data() {
    return {
      user: new User(),

      fetch: {
        roles: [],
      },

      alert: {
        show: false,
        message: null,
      },

      passwordsMatch: true,
    };
  },

  computed: {
    isCreating() {
      return this.id === null;
    },
  },

  methods: {
    async fetchModel() {
      var response = await axios.get(route("users.show", { user: this.id }));
      if (response.status != 200) {
        this.$awn.alert("Errore nel server");
      }
      this.user = response.data.data;
    },

    async fetchRoles() {
      var response = await axios.get(route("roles.index"));
      if (response.status == 200) {
        this.fetch.roles = response.data.data;
      }
    },

    validate() {
      return this.$refs.form.reportValidity();
      //   return this.user.validate();
    },

    checkPasswordMatch() {
      return (this.passwordsMatch =
        this.user.password === this.user.passwordRetype);
    },

    async submit() {
      if (!this.validate()) {
        this.alert.show = true;
        this.alert.message = "Alcuni campi richiesti non sono stati compilati";
        return false;
      }
      if (this.id) {
        var response = await axios.put(route("users.update", this.user ), this.user);
      } else {
        var response = await axios.post(route("users.store", this.user));
      }
      if (response.status == 200) {
        this.$awn.success("Utente creato");
      } else {
        this.$awn.alert("Si è verficato un errore: " + response.error);
      }
    },
  },

  mounted() {
    if (this.id) {
      this.fetchModel();
    }

    this.fetchRoles();
  },
};
</script>
